const host_state = true //true为正式，false为测试

// 测试接口
let host = '//rt-marketing.52shanglu.com';
// let host = 'https://shopingapi.guogekeji.com';
let uploadUrl = 'https://crm-img.runtian.cn/marketing/img'

if (host_state) {
    // 正式接口
    host = '//marketing-api.runtian.cn';
}

export default {
    host,
    uploadUrl,
}